var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c("custom-callout", { attrs: { "has-toggle": false } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-sm-5 col-xl-3 my-2 border-right d-flex flex-column justify-content-center align-items-start",
              staticStyle: { padding: "0 40px" }
            },
            [
              _c(
                "span",
                {
                  staticClass: "badge badge-pill mb-2 font-16",
                  class: [`badge-${_vm.sufixType}`]
                },
                [_vm._v(" " + _vm._s(_vm.name) + " ")]
              ),
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("Número de Aviso:")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-normal color-black font-16" },
                [_c("b", [_vm._v(_vm._s(_vm.code))])]
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "col-sm-7 col-xl-6",
              staticStyle: { padding: "0 40px" }
            },
            [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v(" Nombre del Aviso: ")
              ]),
              _c(
                "div",
                { staticClass: "font-weight-normal color-black font-16" },
                [_vm._v(" " + _vm._s(_vm.description) + " ")]
              ),
              _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-md-6 col-xl-3" }, [
                  _c("div", { staticClass: "color-secondary-6 font-14" }, [
                    _vm._v(" Fecha de Publicación: ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-weight-normal color-black font-16" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm._f("date")(_vm.publishDate)) + " "
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "col-md-6 col-xl-3" }, [
                  _c("div", { staticClass: "color-secondary-6 font-14" }, [
                    _vm._v(" Fecha de Finalización: ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-weight-normal color-black font-16" },
                    [_vm._v(" " + _vm._s(_vm._f("date")(_vm.finishDate)) + " ")]
                  )
                ])
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "col-md-12 col-xl-3 text-right d-flex justify-content-center align-items-center"
            },
            [
              _c("dropdown", {
                staticClass: "actions-dropdown",
                attrs: {
                  id: `announcement-btn-${_vm.id}`,
                  items: _vm.actionItems,
                  title: " Acciones "
                }
              })
            ],
            1
          )
        ])
      ]),
      !_vm.isFinished
        ? _c("div", { staticClass: "alert alert-warning" }, [
            _c("i", { staticClass: "fas fa-bell-exclamation mr-2" }),
            _vm._v(
              " Al culminar la fecha de finalización podrá comenzar con el proceso de determinación de las propuestas de servicio. "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }